// extracted by mini-css-extract-plugin
module.exports = {"form":"_2c42edb","seasonsDropdown":"_940dd13","seasonsDropdownSkeleton":"_09e4660","hiddenOnMobile":"_457af74"};